import React, {useEffect} from 'react';
import { withStyles } from '@material-ui/core/styles';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

const GreenCheckbox = withStyles({
  root: {
    color: "#0000008a",
    '&$checked': {
      color: '#699e42',
    },
  },
  checked: {},
})(props => <Checkbox color="default" {...props} />);

export default function CheckboxDefault(props) {
  const [state, setState] = React.useState({
    checkbox: false,
  });

  const {clearAll, checked,checkboxName , getCheckboxSelected} = {...props};

  useEffect(() => {
    if (clearAll) {
      setState(prevState  => ({ ...prevState, checkbox: false}));
      
      getCheckboxSelected(checkboxName, false);
    }
  }, [clearAll, checkboxName, setState, getCheckboxSelected])

  useEffect(() => {
    if (checked) {
      setState(prevState  => ({ ...prevState, checkbox: true}));
      
      getCheckboxSelected(checkboxName, true);
    }
  }, [checked, checkboxName, setState, getCheckboxSelected])

  const handleChange = name => event => {
    setState(prevState => ({ ...prevState, [name]: event.target.checked }));

    getCheckboxSelected(event.target.value, event.target.checked)
  };

  return (
    <FormGroup>
      <FormControlLabel
        control={
          <GreenCheckbox
            checked={state.checkbox}
            onChange={handleChange('checkbox')}
            value={props.checkboxName.toString()}
            disabled={props.disabled}
          />
        }
        label={props.checkboxName.toString()}
      />
    </FormGroup>
  );
}
